if (!customElements.get('countdown-timer')) {
  customElements.define(
    'countdown-timer',
    class CountdownTimer extends HTMLElement {
      constructor() {
        super();
        this.storeNow = Number(this.dataset.storeNow) * 1000; // ms
        this.timeOffset = this.storeNow - Date.now(); // store vs local difference
        this.targetDate = Number(this.dataset.targetDate) * 1000; // ms;
        this.message = this.dataset.message;
        this.timeLeftMessage = this.dataset.timeLeftMessage;
        this.countdownType = this.dataset.countdownType;
        this.bannerElement = this;
        this.countdownElement = this.querySelector('[data-countdown-timer]');
        this.countdownGridDay = this.querySelector('[data-countdown-grid-day]');
        this.countdownGridHour = this.querySelector('[data-countdown-grid-hour]');
        this.countdownGridMinute = this.querySelector('[data-countdown-grid-minute]');
        this.countdownGridSecond = this.querySelector('[data-countdown-grid-second]');
        this.interval = null;
        this.dayInMS = 24 * 60 * 60 * 1000;

        if (this.countdownType === 'daily') {
          this.targetDate = this.getResetTime();
        }
      }

      connectedCallback() {
        // Start the countdown immediately
        this.updateCountdown();

        // Update every second
        this.interval = setInterval(() => {
          this.updateCountdown();
        }, 1000);
      }

      disconnectedCallback() {
        // Clean up the interval when the element is removed
        if (this.interval) {
          clearInterval(this.interval);
        }
      }

      updateCountdown() {
        // For daily countdowns, ensure targetDate is always fresh first
        if (this.countdownType === 'daily') {
          this.targetDate = this.getResetTime();
        }

        // Now calculate remaining time
        const timeRemaining = Math.max(0, this.targetDate - Date.now());

        // Hide promo countdowns when finished
        if (this.countdownType !== 'daily' && timeRemaining <= 0) {
          this.bannerElement.classList.add('hidden');
          clearInterval(this.interval);
          return;
        }

        // Calculate time units
        const totalSeconds = Math.floor(timeRemaining / 1000);
        const days = Math.floor(totalSeconds / 86400);
        const hours = Math.floor((totalSeconds % 86400) / 3600);
        const minutes = Math.floor((totalSeconds % 3600) / 60);
        const seconds = totalSeconds % 60;

        if (this.countdownGridDay) {
          this.countdownGridDay.textContent = days;
          this.countdownGridHour.textContent = hours;
          this.countdownGridMinute.textContent = minutes;
          this.countdownGridSecond.textContent = seconds;
          return;
        }

        // Format the countdown display
        let countdownText = '';

        if (days > 0) countdownText += `${days}d `;
        countdownText += `${this.padZero(hours)}h ${this.padZero(minutes)}m ${this.padZero(seconds)}s`;
        this.countdownElement.textContent = countdownText;
      }

      getResetTime() {
        return Date.now() >= this.targetDate ? (this.targetDate += this.dayInMS) : this.targetDate;
      }

      padZero(number) {
        return number < 10 ? `0${number}` : number;
      }
    }
  );
}
